import { createFileRoute, redirect } from '@tanstack/react-router';

// Most Scouted now lives as a section of the combined A&R page (/briefs).
// Keep this URL working for old links and bookmarks by redirecting to it.
export const Route = createFileRoute('/scouted')({
  beforeLoad: () => {
    throw redirect({ to: '/briefs', hash: 'scouted' });
  },
});
